import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import api, { formatApiError } from "../../lib/api";
import SEO from "../../components/site/SEO";
import { inputCls, labelCls, btnPrimaire } from "./ui";

const VIDE = { ancien: "", nouveau: "", confirmation: "" };

export default function AdminMotDePasse() {
  const [form, setForm] = useState(VIDE);
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);

  const soumettre = async (e) => {
    e.preventDefault();
    setErreur("");
    if (form.nouveau.length < 8) {
      setErreur("Le nouveau mot de passe doit contenir au moins 8 caractères.");
      return;
    }
    if (form.nouveau !== form.confirmation) {
      setErreur("La confirmation ne correspond pas au nouveau mot de passe.");
      return;
    }
    setEnvoi(true);
    try {
      await api.post("/admin/mot-de-passe", {
        ancien_mot_de_passe: form.ancien,
        nouveau_mot_de_passe: form.nouveau,
      });
      toast.success("Votre mot de passe a été changé.");
      setForm(VIDE);
    } catch (err) {
      setErreur(formatApiError(err.response?.data?.detail));
    } finally {
      setEnvoi(false);
    }
  };

  return (
    <div className="max-w-xl" data-testid="admin-mot-de-passe">
      <SEO title="Changer mon mot de passe — Espace gérant | Promo Pneus" description="Changer le mot de passe de l'espace gérant." />
      <h1 className="font-heading font-bold uppercase text-4xl text-brand-dark tracking-tight mb-2">
        Changer mon mot de passe
      </h1>
      <p className="text-brand-body text-lg mb-8">
        Choisissez un mot de passe que vous retiendrez facilement, d'au moins 8 caractères.
        Notez-le quelque part : il n'y a pas de récupération par email.
      </p>

      <form onSubmit={soumettre} className="space-y-5 bg-white p-6 shadow-sm">
        <div>
          <label htmlFor="mdp-actuel" className={labelCls}>Mot de passe actuel</label>
          <input id="mdp-actuel" data-testid="mdp-actuel" type="password" required
            value={form.ancien} onChange={(e) => setForm({ ...form, ancien: e.target.value })}
            autoComplete="current-password" className={inputCls}
            placeholder="Votre mot de passe actuel" />
        </div>
        <div>
          <label htmlFor="mdp-nouveau" className={labelCls}>Nouveau mot de passe</label>
          <input id="mdp-nouveau" data-testid="mdp-nouveau" type="password" required minLength={8}
            value={form.nouveau} onChange={(e) => setForm({ ...form, nouveau: e.target.value })}
            autoComplete="new-password" className={inputCls}
            placeholder="Au moins 8 caractères" />
        </div>
        <div>
          <label htmlFor="mdp-confirmation" className={labelCls}>Confirmer le nouveau mot de passe</label>
          <input id="mdp-confirmation" data-testid="mdp-confirmation" type="password" required
            value={form.confirmation} onChange={(e) => setForm({ ...form, confirmation: e.target.value })}
            autoComplete="new-password" className={inputCls}
            placeholder="Retapez le nouveau mot de passe" />
        </div>
        {erreur && (
          <p data-testid="mdp-erreur" role="alert"
            className="text-brand-redhover font-medium bg-red-50 border-l-4 border-brand-red px-4 py-3">
            {erreur}
          </p>
        )}
        <button type="submit" data-testid="mdp-valider" disabled={envoi}
          className={`${btnPrimaire} w-full inline-flex items-center justify-center gap-2`}>
          <KeyRound size={20} aria-hidden="true" />
          {envoi ? "Enregistrement…" : "Changer mon mot de passe"}
        </button>
      </form>
    </div>
  );
}
